import React from 'react';
import bigLogoPlug from '../../assets/img/big-logo.png';
import smallLogoPlug from '../../assets/img/small-logo.png';
import CustomInput, { ErrorText } from '../CustomInput/CustomInput';
import { Upload, Trash } from '../Svg/Svg';

export default function LogosUploaderCrm({
    onFileSelect,
    bigLogo,
    faviconLogo,
    bigLogoErrors,
    faviconLogoErrors,
    onDeleteBigLogo,
    onDeleteFaviconLogo,
    bigLogoButtonRef,
    faviconLogoButtonRef,
    logosSizes,
    onLogosSizesChange,
}) {
    return (
        <div className="form__upload-wrapper">
            <div className="form__upload-thumb">
                <p className="form__upload-title">Logo</p>
                <div className="form__upload-container">
                    <img
                        className="form__upload-image"
                        width={64}
                        height={64}
                        src={bigLogo.logoUrl || bigLogoPlug}
                        alt="Big logo"
                    />
                    <div className="form__upload">
                        <div className="form__upload-buttons-wrapper">
                            <input
                                type="file"
                                name="big-logo"
                                id="big-logo"
                                ref={bigLogoButtonRef}
                                className="input-file"
                                accept="image/svg, image/png, image/jpeg"
                                onChange={onFileSelect}
                            />
                            <label
                                className="form__upload-button"
                                htmlFor="big-logo"
                            >
                                <Upload />
                                <span className="form__upload-button-text">
                                    Upload
                                </span>
                            </label>
                            {bigLogo.logoUrl ? (
                                <button
                                    className="form__trash-button"
                                    name="big-logo"
                                    onClick={onDeleteBigLogo}
                                >
                                    <Trash />
                                </button>
                            ) : (
                                <div
                                    style={{
                                        width: '32px',
                                        height: '32px',
                                    }}
                                ></div>
                            )}
                        </div>
                        <span className="form__upload-text">
                            64 x 64&nbsp;&nbsp;
                            <span className="form__upload-text-devider">
                                &bull;
                            </span>
                            &nbsp;&nbsp; svg or png
                        </span>
                    </div>
                </div>
                {bigLogoErrors.isWrongFileType && (
                    <ErrorText text={'Wrong file format'} />
                )}
                {bigLogoErrors.isFileOversized && (
                    <ErrorText text={'The file size must not exceed 2MB'} />
                )}
                <div style={{ display: 'flex', marginTop: '10px' }}>
                    <div style={{ maxWidth: '100px', marginRight: '10px' }}>
                        <CustomInput
                            id="logo_width"
                            onInputChange={onLogosSizesChange}
                            inputValue={logosSizes?.crm?.logo?.width}
                            type="number"
                            labelClass="input-label--normal"
                            labelText="Logo width (px)"
                            width="100%"
                        />
                    </div>
                    <div style={{ maxWidth: '100px' }}>
                        <CustomInput
                            id="logo_height"
                            onInputChange={onLogosSizesChange}
                            inputValue={logosSizes?.crm?.logo?.height}
                            labelText="Logo height (px)"
                            labelClass="input-label--normal"
                            type="number"
                            width="100%"
                        />
                    </div>
                </div>
            </div>
            <div>
                <p className="form__upload-title">Favicon</p>
                <div className="form__upload-container">
                    <img
                        className="form__upload-image"
                        src={faviconLogo.logoUrl || smallLogoPlug}
                        alt="favicon logo"
                        width={32}
                        height={32}
                    />
                    <div className="form__upload">
                        <div className="form__upload-buttons-wrapper">
                            <input
                                type="file"
                                name="favicon-logo"
                                id="favicon-logo"
                                ref={faviconLogoButtonRef}
                                className="input-file"
                                accept="image/svg, image/png, image/jpeg"
                                onChange={onFileSelect}
                            />
                            <label
                                className="form__upload-button"
                                htmlFor="favicon-logo"
                            >
                                <Upload />
                                <span className="form__upload-button-text">
                                    Upload
                                </span>
                            </label>
                            {faviconLogo.logoUrl ? (
                                <button
                                    className="form__trash-button"
                                    name="favicon-logo"
                                    onClick={onDeleteFaviconLogo}
                                >
                                    <Trash />
                                </button>
                            ) : (
                                <div
                                    style={{
                                        width: '32px',
                                        height: '32px',
                                    }}
                                ></div>
                            )}
                        </div>
                        <span className="form__upload-text">
                            32 x 32&nbsp;&nbsp;
                            <span className="form__upload-text-devider">
                                &bull;
                            </span>
                            &nbsp;&nbsp; svg or png
                        </span>
                    </div>
                </div>
                {faviconLogoErrors.isWrongFileType && (
                    <ErrorText text={'Wrong file format'} />
                )}
                {faviconLogoErrors.isFileOversized && (
                    <ErrorText text={'The file size must not exceed 2MB'} />
                )}
            </div>
        </div>
    );
}
